// extracted by mini-css-extract-plugin
export default {"root":"_289Qz","vertical":"cImtM","horizontal":"_1u1yt","detail":"_2lT7X"};